<ng-container *ngIf="determineIfIsArlTableDataOrGroupEnd(rowData) && (rowData.isBookingPosition$ | async)">
    <div *ngIf="rowData.isExpanded$ && rowData.isExpanded$ | async; else value">
        <ng-container *ngIf="!rowData.form.value.InheritFromChildren; else value">
            <div class="flex gap-2">
                <mat-form-field *ngIf="!useArlSeparateSalaryBaseCost; else value">
                    <mat-label>{{ baseCostLabel }}</mat-label>
                    <app-number-transform-input [factor]="1" [formControl]="rowData.form.controls.BaseCost"  (ngModelChange)="baseCostChange.emit($event)"></app-number-transform-input>
                    <mat-error class="form-field-error" *ngIf="rowData.form.controls.BaseCost.invalid">
                        {{ getErrorMessage(rowData.form.controls.BaseCost) }}
                    </mat-error>
                </mat-form-field>
                <!--                                    <div>-->
                <!--                                        {{rowData.baseCostWithArlAllowances$ | async | currency: rowData.entity.CurrencyCode}}-->
                <!--                                    </div>-->
            </div>

            <div class="flex flex-col mt-2">
                <mat-form-field>
                    <mat-label>Kosten</mat-label>
                    <app-number-transform-input
                        [formControl]="rowData.form.controls.CostAmount"
                        (blur)="costAmountBlur.emit()"
                        (ngModelChange)="costAmountChange.emit($event)"
                    ></app-number-transform-input>
                    <mat-error class="form-field-error" *ngIf="rowData.form.controls.CostAmount.invalid">
                        {{ getErrorMessage(rowData.form.controls.CostAmount) }}
                    </mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Zuschlag</mat-label>
                    <app-hint-icon
                        *ngIf="isNotNullOrUndefined(rowData.form.controls.SurchargeOverride.getRawValue())"
                        hint="Zuschlag wurde an einem Titel überschrieben. Vorbewertungen und Erhöhung / Minderung werden nicht berücksichtigt bis der Zuschlag entfernt wird"
                        matPrefix class="mr-2"
                    ></app-hint-icon>

                        <app-number-transform-input
                            [disabled]="disabledSurchargeInput"
                            [ngModel]="isNotNullOrUndefined(rowData.form.controls.SurchargeOverride.getRawValue()) ? rowData.form.controls.SurchargeOverride.value : rowData.surchargePercentForm.value"
                            (ngModelChange)="surchargePercentChange.emit($event)"></app-number-transform-input>
                    <span matSuffix>%</span>
                </mat-form-field>
            </div>
        </ng-container>
    </div>

    <ng-template #value>
        <div class="cross-except-last-price">
            <span class="price">{{ rowData.form.value.BaseCost | currency: rowData.entity.CurrencyCode }}</span>
            <ng-container *ngIf="rowData.baseCostsWithAllowanceCharges$ | async as baseCostData">
                <!--                                    <ng-container *ngIf="baseCostData.salaryBaseCostWithArlCharges as v">{{ v | currency: rowData.entity.CurrencyCode }}</ng-container>-->
                <ng-container *ngIf="isNotNullOrUndefined(baseCostData.baseCostWithArlAllowanceCharges) && baseCostData.baseCostWithArlAllowanceCharges !== rowData.form.value.BaseCost">
                    <br>
                    <span class="price">{{ baseCostData.baseCostWithArlAllowanceCharges | currency: rowData.entity.CurrencyCode }}</span>
                </ng-container>
            </ng-container>
        </div>
    </ng-template>

    <ng-container *ngIf="rowData.form?.controls.Type.value === ARLTypeEnumMaterialArl">
        <button mat-icon-button matTooltip="Preisgestaltung" (click)="priceInformationClick.emit()" [disabled]="!rowData.form.value.MaterialId">
            <fa-icon icon="info-circle"></fa-icon>
        </button>
    </ng-container>
    <ng-container *ngIf="rowData.form?.controls.PriceComparisonId.value">
        <button mat-icon-button matTooltip="Bieter" (click)="bidderClick.emit()" >
            <fa-icon icon="info-circle"></fa-icon>
        </button>
    </ng-container>
</ng-container>
